export default "/images/maybe.svg?2d2d63a8074e050dd1407dd744fc6c34";